import { DEFAULT_PRODUCT_FAMILY } from '../../constants/productFamily';
import * as actionType from './actionTypes';

const initialState = {
  selectedProduct: DEFAULT_PRODUCT_FAMILY,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.payload };
    default:
      return state;
  }
};

export default reducer;
